export const catalogHitTpl = `
<article class="px-4 sm:px-6">
    <a href="{{ url }}"
        class="flex w-full items-center hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
        <!-- image -->
        <div class="h-16 md:h-24 w-16 md:w-24">
         {{#thumbnail}}
            <img class="w-full" src="{{ thumbnail }}" />
         {{/thumbnail}}
        </div>

        <!-- content and tag -->
        <div class="flex-1 flex pl-4">
            <div class="lg:w-3/4">
                <h3 class="text-base leading-tight font-semibold text-gray-900">
                    {{ title }}
                </h3>
                <div class="mt-2 flex items-center text-xs text-gray-600">
                    Product #:
                    <span class="ml-1 truncate">{{ sku }}</span>
                </div>
            </div>
            <div class="hidden md:block">
              {{#Product Category}}
                <p class="font-bold text-2xs mr-1 inline-block px-3 py-1 my-1 font-medium text-blue-400 bg-lightblue-100">
                  {{.}}
                </p>
              {{/Product Category}}
          </div>
        </div>

        <svg class="h-5 w-5 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"></path>
        </svg>
    </a>
</article>


    `;
